import { SelectProps } from "@mui/material";
import { ConditionValueSelectorComponentProps } from "../ConditionForm";
import EnumSelect from "../../../common/EnumSelect";
import enumLabel from "../../../../utils/labels/enumLabel";
import { FuelCostBasis } from "../../../../graphql/generated";

export const DEFAULT_FUEL_COST_BASIS = FuelCostBasis.LastDropoff;

const FuelCostBasisSelect = ({
  value,
  onChange,
  ...otherProps
}: ConditionValueSelectorComponentProps & Pick<SelectProps<string>, "sx">) => (
  <EnumSelect data-testid="fuel-cost-basis-select-fuel-cost-basis"
    label={otherProps.label}
    size="small"
    enumObject={FuelCostBasis}
    value={(value as FuelCostBasis) || DEFAULT_FUEL_COST_BASIS}
    onChange={(event, value) => {
      onChange(value);
    }}
    optionLabel={(option) => enumLabel(option) || option}
    {...otherProps}
  />
);

export default FuelCostBasisSelect;
